import { c as _c } from "react/compiler-runtime";
import { useNProgress } from '@tanem/react-nprogress';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { isIe } from '#cutils/misc/isIe';
import styles from './LoadingBar.module.scss';
export function LoadingBar() {
  const $ = _c(18);
  const router = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      isRouteChanging: false,
      loadingKey: 0
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [state, setState] = useState(t0);
  let t1;
  let t2;
  if ($[1] !== router.events) {
    t1 = () => {
      const handleRouteChangeStart = function handleRouteChangeStart() {
        setState(_temp);
      };
      const handleRouteChangeEnd = function handleRouteChangeEnd() {
        setState(_temp2);
      };
      router.events.on("routeChangeStart", handleRouteChangeStart);
      router.events.on("routeChangeComplete", handleRouteChangeEnd);
      router.events.on("routeChangeError", handleRouteChangeEnd);
      return () => {
        router.events.off("routeChangeStart", handleRouteChangeStart);
        router.events.off("routeChangeComplete", handleRouteChangeEnd);
        router.events.off("routeChangeError", handleRouteChangeEnd);
      };
    };
    t2 = [router.events];
    $[1] = router.events;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== state.isRouteChanging) {
    t3 = {
      isAnimating: state.isRouteChanging
    };
    $[4] = state.isRouteChanging;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    animationDuration,
    isFinished,
    progress
  } = useNProgress(t3);
  if (isIe()) {
    return null;
  }
  const t4 = `${styles.container} ${isFinished ? styles.finished : ""}`;
  const t5 = `opacity ${animationDuration}ms linear`;
  let t6;
  if ($[6] !== t5) {
    t6 = {
      transition: t5
    };
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = `${(-1 + progress) * 100}%`;
  const t8 = `margin-left ${animationDuration}ms linear`;
  let t9;
  if ($[8] !== t7 || $[9] !== t8) {
    t9 = {
      marginLeft: t7,
      transition: t8
    };
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className={styles.spinner} />;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t9) {
    t11 = <div className={styles.bar} style={t9}>{t10}</div>;
    $[12] = t9;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11 || $[15] !== t4 || $[16] !== t6) {
    t12 = <div className={t4} style={t6}>{t11}</div>;
    $[14] = t11;
    $[15] = t4;
    $[16] = t6;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  return t12;
}
function _temp2(prevState_0) {
  return {
    ...prevState_0,
    isRouteChanging: false
  };
}
function _temp(prevState) {
  return {
    ...prevState,
    isRouteChanging: true,
    loadingKey: prevState.loadingKey ^ 1
  };
}